module.exports = __webpack_public_path__ + "static/img/netflix-right.72cad3f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/netflix-right.png
// module id = 331
// module chunks = 1